import { useDrawer } from 'components/drawers/inc-drawer/inc-drawer.hooks';
import { CreateRelatedLocationDrawerDataType } from './create-related-location-drawer.component';

export const useCreateRelatedLocationDrawer = () =>
  useDrawer<CreateRelatedLocationDrawerDataType>();
